import instance from './instances/ancillary-service';

export function getServices(student_id) {
    return instance.get(`v1/ancillary-services/${student_id}`);
}
export function postServices(data, student_id) {
    return instance.post(`v1/ancillary-services/${student_id}`, data);
}
